import { render, staticRenderFns } from "./vc-mutil-checkbox.vue?vue&type=template&id=8ba00ef6&scoped=true&"
import script from "./vc-mutil-checkbox.vue?vue&type=script&lang=js&"
export * from "./vc-mutil-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./vc-mutil-checkbox.vue?vue&type=style&index=0&id=8ba00ef6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba00ef6",
  null
  
)

export default component.exports